import { createStore } from '@stencil/store';
import { ProvidersConf } from 'client/types';
import { SofiaMode } from 'types';
import { setRootVariable } from 'utils/shared';
import { getProviderConfig } from '../client';

interface ProviderConfStore {
  conf: ProvidersConf;
  status: 'LOADING' | 'DONE' | 'ERROR';
}

const { state, onChange } = createStore<ProviderConfStore>({
  conf: {
    avatarImg: null,
    features: [],
    footer: {
      termsAndConditionLink: '',
      privacyPoliciesLink: '',
    },
    initPreconditions: [],
  },
  status: 'LOADING',
});

onChange('conf', providerConf => {
  if (!!providerConf?.overrideStyles?.brandPrimary2 && !!providerConf?.overrideStyles?.brandPrimary3) {
    setRootVariable('--brand-primary-2', providerConf.overrideStyles.brandPrimary2);
    setRootVariable('--brand-primary-3', providerConf.overrideStyles.brandPrimary3);
  }
});

async function getProviderConfiguration(assistantId: string, mode: SofiaMode, sandbox: boolean, locale: string): Promise<ProvidersConf> {
  if (state.status === 'DONE') {
    console.debug('Provider conf already loaded, returning it.');
    return Promise.resolve(state.conf);
  } else {
    console.debug('Get provider conf with assistantId:', assistantId, ', mode:', mode, ', locale: ', locale);
    return getProviderConfig({
      mode: mode,
      sandbox: sandbox,
      assistantId: assistantId,
      locale,
    })
      .then(providerConf => {
        console.debug('Provider configuration: ', providerConf);
        state.conf = { ...state.conf, ...providerConf };
        state.status = 'DONE';
        return state.conf;
      })
      .catch(error => {
        console.error('Error getting provider conf', error);
        state.status = 'ERROR';
        return Promise.reject(error);
      });
  }
}

export default state;
export { getProviderConfiguration, state as providerConfState };
